import { UrlObject } from 'url';

/**
 * Serializes a UrlObject to a string href suitable for <a> tags.
 * Filters out undefined/null query values to prevent "?key=undefined" in URLs.
 */
export function urlObjectToString(urlObj: UrlObject): string {
  const { pathname, query } = urlObj;
  let qs = '';
  if (query && typeof query === 'object') {
    const filtered = Object.entries(query).filter(
      (entry): entry is [string, string] => typeof entry[1] === 'string',
    );
    qs = new URLSearchParams(filtered).toString();
  } else if (typeof query === 'string') {
    qs = query;
  }
  const base = pathname ?? '#';
  return qs ? `${base}?${qs}` : base;
}
